<template>

<main class="py-12 space-y-12">
        <section>
            <div class="container">
                <article class="space-y-8">
                    <h1>Newsletter-Abmeldung</h1>

                    <form
                        class="contact-form space-y-4 py-4 text-xs lg:space-y-8 lg:py-0 lg:text-base"
                        method="post"
                        action="https://008.frnl.de/box.php"
                    >
                        <input
                            id="p"
                            name="p"
                            type="hidden"
                            value="2265"
                        >
                        <input
                            name="mlt"
                            type="hidden"
                            value="no"
                        >
                        <input
                            name="action"
                            type="hidden"
                            value="subscribe"
                        >
                        <input
                            name="mode"
                            type="hidden"
                            value="view_unsubscribe"
                        >
                        <input
                            type="hidden"
                            name="nl"
                            :value="config.public.newsletterGroupId"
                        >
                        <UFormField
                            label="E-Mail"
                            required
                        >
                            <UInput
                                id="email"
                                v-model="email"
                                type="email"
                                name="email"
                                class="w-full"
                            />
                            <div
                                v-if="errorEmail"
                                class="text-primary text-xs"
                            >
                                Bitte geben Sie Ihre E-Mail-Adresse ein!
                            </div>
                        </UFormField>
                        <p>
                            <input
                                id="box_preset"
                                name="box_preset"
                                type="hidden"
                                value="1"
                            >
                          <UButton
                                type="submit"
                                label="Abmelden"
                          />
                            <input
                                type="hidden"
                                name="funcml"
                                value="unsub2"
                            >
                        </p>
                    </form>
                </article>
            </div>
        </section>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/Newsletter-Abmeldung',
});

const route = useRoute();
const config = useRuntimeConfig();

const {public: pub} = useRuntimeConfig();
const toast = useToast();

const email = ref('');
const privacy = ref(false);
const errorEmail = ref(false);
const errorPrivacy = ref(false);
const submitting = ref(false);

const formRef = ref(null);

const mailSent = ref(false);

async function sendMessage() {
    const response = await $fetch<{ sent: boolean }>(`${pub.apiUrl}/api/newsletter`, {
        method: 'POST',
        body: {
            email: email.value,
        },
    });

    if (response.sent) {
        toast.add({
            title: 'Erfolgreich versendet',
            description: 'Ihre Nachricht wurde erfolgreich versendet. Bitte prüfen Sie Ihre E-Mail-Nachrichten!',
            color: 'success',
        });
    }

    mailSent.value = true;
}

async function checkPrivacy(e) {
    if (submitting.value) return;
    submitting.value = true;

    if (email.value === '') {
        errorEmail.value = true;
        return;
    }
    errorEmail.value = false;

    if (!privacy.value) {
        errorPrivacy.value = true;
        return;
    }
    errorPrivacy.value = false;
    await sendMessage();
}

onMounted(() => {
    if (route.query?.status === '2' && formRef.value) {
        formRef.value.submit();
    } else if (route.query?.status === '4') {
        email.value = route.query.email;
        toast.add({
            title: 'Erfolgreiche Abfrage',
            description: 'Ihre E-Mail-Adresse befindet sich bereits im Newsletter-Verteiler!',
            color: 'success',
        });
    }
});
</script>

<style scoped>

</style>
